import { ProgressBar } from 'components/ProgressBar'
import { Stack } from 'components/Stack'
import { Text } from 'components/Typography'
import { useTranslation } from 'next-i18next'
import React from 'react'

export type DirectiveProgressProps = {
  /**
   * Number from 0 to 1, 0 means 0 %, 1 means 100 %, 0.35 means 35 %.
   */
  progress: number
  encouragementText?: string
  order: ['text', 'progress-bar'] | ['progress-bar', 'text']
}

export const DirectiveProgress: React.FC<React.PropsWithChildren<DirectiveProgressProps>> = (
  props
) => {
  const { t } = useTranslation('directive')
  const progressTextElement = (
    <div>
      <Text variant={'bodyBold'} color={'var(--c-blue500)'}>
        {t('directive.progress.completion', {
          percentage: Math.round(props.progress * 100) + ' %',
        })}
      </Text>
    </div>
  )
  const progressBarElement = <ProgressBar progress={props.progress} height={6} />

  return (
    <div>
      {props.encouragementText && (
        <div>
          <Text variant={'body'}>{props.encouragementText}</Text>
        </div>
      )}
      <Stack space={'0.5rem'}>
        {props.order.map((val) => {
          return (
            <React.Fragment key={val}>
              {val === 'progress-bar' ? progressBarElement : progressTextElement}
            </React.Fragment>
          )
        })}
      </Stack>
    </div>
  )
}
